import React from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import TestimonialUser1 from '../assets/images/testimonial-user-1.png';
import TestimonialUser2 from '../assets/images/testimonial-user-2.png';
import TestimonialUser3 from '../assets/images/testimonial-user-3.png';
import TestimonialUser4 from '../assets/images/testimonial-user-4.png';
import RedArrow from '../assets/images/about-us/right-arrow.svg';

const ClientsTrust = () => {
   return (
    <section className="clients-trust-section">
      <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="about-content">
                <h1 className="about-title">
                  <span className='red'>1250+</span> Clients <br/>Trust by us.
                </h1>
                <div className="client-avatar-group">
                  <img src={TestimonialUser1} alt="Client" className="client-avatar" />
                  <img src={TestimonialUser2} alt="Client" className="client-avatar" />
                  <img src={TestimonialUser3} alt="Client" className="client-avatar" />
                  <img src={TestimonialUser4} alt="Client" className="client-avatar" />
                  <span className="client-avatar client-avatar-more">+</span>
                </div>
              </div>
            </Col>
            <Col lg={6} md={12}>
               <div className="about-content">
                <p className="about-description">Your leading real estate advocate, transforming houses into dreams. Trust us to expertly guide you home. 45,000 apartments & home for sell, rent & mortgage.</p>
                <div className="button-group">
                  <Button
                      className="custom-bttn"
                    >
                      More Listing
                    </Button>
                  <Button variant="link" className="request-callback-link">
                    Request a Callback
                    <img src={RedArrow} alt="" />
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
    </section>
  );
}

export default ClientsTrust;